/** 站长独立手机端路径（微信内打开） */
export const siteMasterPaths = {
  login: '/w/login',
  home: '/w/home',
  add: '/w/add',
  entries: '/w/entries',
  ads: '/w/ads',
  forward: '/w/forward',
  profile: '/w/profile',
  mp: '/w/mp',
  analytics: '/w/analytics',
  analyticsFor: (id: number) => `/w/analytics/${id}`,
} as const;

export function siteMasterLoginUrl(returnTo?: string): string {
  if (!returnTo || returnTo.startsWith(siteMasterPaths.login)) {
    return siteMasterPaths.login;
  }
  const q = new URLSearchParams({ next: returnTo });
  return `${siteMasterPaths.login}?${q.toString()}`;
}
